import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigurationTypeCodeLink } from "./ConfigurationTypeCodeLink";
import { ConfigurationTypeCodeText } from "./ConfigurationTypeCodeText";
export var ConfigurationTypeCodeVariant;
(function (ConfigurationTypeCodeVariant) {
    ConfigurationTypeCodeVariant["Text"] = "text";
    ConfigurationTypeCodeVariant["Link"] = "link";
})(ConfigurationTypeCodeVariant || (ConfigurationTypeCodeVariant = {}));
export function ConfigurationTypeCode(props) {
    const { variant = ConfigurationTypeCodeVariant.Text } = props;
    if (variant === ConfigurationTypeCodeVariant.Link) {
        return _jsx(ConfigurationTypeCodeLink, {});
    }
    return _jsx(ConfigurationTypeCodeText, {});
}
//# sourceMappingURL=ConfigurationTypeCode.js.map